<template>
  <div>
    <div class="myHead">
      <el-breadcrumb style="margin-top: 10px ;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: 'equAccount'}">设备设施管理</el-breadcrumb-item>
        <el-breadcrumb-item>保养维修记录</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.query.pageStatus == 1 ? '维修' : '保养' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bodyBox">
      <template>
        <el-row>
          <el-col :span="24">
            <!-- 添加维修 -->
              <div class="wxBox" v-if="$route.query.pageStatus == 1">
              <el-form ref="form" :model="form" label-width="280px" :rules="rules">
                <el-form-item label="名称" prop="name">
                  <el-input v-model="form.name" size="small" style="width: 800px"></el-input>
                </el-form-item>
                <el-form-item label="设备" prop="equipmentId">
                  <el-select v-model="form.equipmentId" placeholder="请选择设备" size="small" style="width: 800px">
                    <el-option v-for="item in equipmentArr" :key="item.id" :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                  <el-date-picker
                      v-model="form.startTime"
                      type="date" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择开始时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                  <el-date-picker
                      v-model="form.endTime"
                      type="date" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择结束时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="责任人" prop="userId">
                  <el-select v-model="form.userId" placeholder="请选择责任人" size="small" style="width: 800px">
                    <el-option :value="item.id" v-for="item in selectArr" :key="item.id"
                               :label="item.nickname">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="维修内容" prop="maintainContent">
                  <el-input type="textarea" v-model="form.maintainContent" size="small" style="width: 800px"></el-input>
                </el-form-item>
                <el-form-item label="附图">
                  <el-upload
                      class="avatar-uploader"
                      action="/v1/equipmentMaintain/uploadFile"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" style="margin-left: 200px" @click="addWx">立即创建</el-button>
                  <el-button size="small" style="margin-left: 50px" @click="$router.push('equAccount')">取消</el-button>
                </el-form-item>
              </el-form>
            </div>

            <!-- 添加保养  -->
            <div class="wxBox" v-if="$route.query.pageStatus == 2">
              <el-form ref="form2" :model="form2" label-width="280px" :rules="rules2">
                <el-form-item label="名称" prop="name">
                  <el-input v-model="form2.name" size="small" style="width: 800px"></el-input>
                </el-form-item>
                <el-form-item label="设备" prop="equipmentId">
                  <el-select v-model="form2.equipmentId" placeholder="请选择设备" size="small" style="width: 800px">
                    <el-option v-for="item in equipmentArr" :key="item.id" :label="item.name"
                               :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                  <el-date-picker
                      v-model="form2.startTime"
                      type="date" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择开始时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="状态">
                  <el-radio-group v-model="form2.status" size="small">
                    <el-radio-button :label="0">未完成</el-radio-button>
                    <el-radio-button :label="1">已完成</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="完成时间" prop="endTime">
                  <el-date-picker
                      v-model="form2.endTime"
                      type="date" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择完成时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="下次保养时间" prop="nextKeepTime">
                  <!-- type="date" size="small" :disabled="$route.query.id !== undefined" -->
                  <el-date-picker
                      v-model="form2.nextKeepTime" value-format="yyyy-MM-dd HH:mm:ss"
                      type="date" size="small"
                      placeholder="请选择下次保养时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="责任人" prop="userId">
                  <el-select v-model="form2.userId" placeholder="请选择责任人" size="small" style="width: 800px">
                    <el-option :value="item.id" v-for="item in selectArr" :key="item.id"
                               :label="item.nickname">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="维护保养内容" prop="keepContent">
                  <el-input type="textarea" v-model="form2.keepContent" size="small" style="width: 800px"></el-input>
                </el-form-item>
                <el-form-item label="附图">
                  <el-upload
                      class="avatar-uploader"
                      action="/v1/equipmentKeep/uploadFile"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess2">
                    <img v-if="form2.imgPath" :src="form2.imgPath" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" style="margin-left: 200px" @click="addBY">保存</el-button>
                  <el-button size="small" style="margin-left: 50px">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </template>
    </div>
  </div>
</template>

<script>
import {
  addEquipmentMaintain,
  addKeepMaintain,
  editEquipmentMaintain,
  editKeepMaintain,
  getAlluser,
  getKeepMaintainDetails,
  getTypeList
} from "@/api/processManager"

export default {
  name: 'addEquAccunt',
  data() {
    return {
      selectArr: [], // 人员下拉框
      equipmentArr: [], // 设备下拉框
      form: {
        name: '',
        equipmentId: '',
        startTime: '',
        endTime: '',
        userId: "",
        maintainContent: '',
        imgName: '',
        imgPath: ''
      },
      rules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        equipmentId: [{required: true, message: '请选择设备', trigger: 'change'}],
        startTime: [{required: true, message: '请选择开始时间', trigger: 'blur'}],
        endTime: [{required: true, message: '请选择结束时间', trigger: 'blur'}],
        userId: [{required: true, message: '请选择责任人', trigger: 'change'}],
        maintainContent: [{required: true, message: '请输入维修内容', trigger: 'blur'}],
      },
      imageUrl: '',
      form2: {
        name: '',
        equipmentId: '',
        startTime: '',
        endTime: '',
        userId: "",
        keepContent: '',
        nextKeepTime: '',
        imgName: '',
        imgPath: '',
        status: 0
      },
      rules2: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        equipmentId: [{required: true, message: '请选择设备', trigger: 'change'}],
        startTime: [{required: true, message: '请选择开始时间', trigger: 'blur'}],
        endTime: [{required: true, message: '请选择完成时间', trigger: 'blur'}],
        nextKeepTime: [{required: true, message: '请选择下次保养时间', trigger: 'blur'}],
        userId: [{required: true, message: '请选择责任人', trigger: 'change'}],
        keepContent: [{required: true, message: '请输入保养内容', trigger: 'blur'}],
      },
    }
  },
  methods: {
    // 维修图片上传成功的回调
    handleAvatarSuccess(res, file) {
      // console.log(file)
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 保养图片上传成功的回调
    handleAvatarSuccess2(res, file) {
      this.form2.imgPath = URL.createObjectURL(file.raw);
    },
    // 维修
    addWx() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.$route.query.id) {
            // 新增
            addEquipmentMaintain({...this.form}).then(res => {
              this.$message.success('新增成功')
              this.$router.push('equAccount')
            })
          } else {
            // 编辑
            editEquipmentMaintain({...this.form}).then(res => {
              this.$message.success('编辑成功')
              this.$router.push('equAccount')
            })
          }
        } else {
          return false;
        }
      })
    },
    // 保养
    addBY() {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          if (!this.$route.query.id) {
            // 新增
            addKeepMaintain({...this.form2}).then(res => {
              this.$message.success('新增成功')
              this.$router.push('equAccount')
            })
          } else {
            // 编辑
            editKeepMaintain({...this.form2}).then(res => {
              this.$message.success('编辑成功')
              this.$router.push('equAccount')
            })
          }
        } else {
          return false;
        }
      })
    }
  },
  created() {
    if (this.$route.query.id) {
      getKeepMaintainDetails({type: this.$route.query.type, id: this.$route.query.id}).then(res => {
        // console.log(res)
        // 维修
        if (this.$route.query.type === 1) {
          this.form = {...res.body.data}
        } else {
          // 保养
          this.form2 = {...res.body.data}
        }
      })
    }
    // 获取人员下拉数据
    getAlluser().then(res => {
      this.selectArr = res.body.data
    })
    // 获取设备下拉数据
    getTypeList({isPage: 0}).then(res => {
      this.equipmentArr = res.body.data
    })
  }
}
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}

.bodyBox {
  width: 100%;
  height: 850px;
  background: white;
  padding: 15px
}

.wxBox /deep/ .el-form-item {
  margin-bottom: 15px
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>